/**
 * HAPiKAS - Modern Header Script
 *
 * This script is self-contained and designed to avoid conflicts with other theme scripts.
 * It uses specific IDs and scoped queries to control the modern header's functionality.
 */
document.addEventListener('DOMContentLoaded', () => {
  const header = {
    toggleButton: document.getElementById('ModernHeader-toggle'),
    mobileMenu: document.querySelector('.mobile-menu'),

    init() {
      if (!this.toggleButton || !this.mobileMenu) {
        // console.error('Modern Header elements not found. Script will not run.');
        return;
      }
      this.initMenuToggle();
      this.initSubmenuAccordion();
      this.initDesktopDropdowns();
    },

    initMenuToggle() {
      this.toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        const isActive = this.toggleButton.classList.toggle('is-active');
        this.mobileMenu.classList.toggle('is-active', isActive);
        document.body.classList.toggle('overflow-hidden', isActive);
        this.toggleButton.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        this.mobileMenu.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        // --- Force-update icon visibility ---
        const hamburgerIcon = this.toggleButton.querySelector('.icon-hamburger');
        const closeIcon = this.toggleButton.querySelector('.icon-close');
        if (hamburgerIcon && closeIcon) {
          if (isActive) {
            hamburgerIcon.style.display = 'none';
            closeIcon.style.display = 'block';
          } else {
            hamburgerIcon.style.display = 'block';
            closeIcon.style.display = 'none';
          }
        }
        // ------------------------------------
      });
    },

    initDesktopDropdowns() {
      const desktopNav = document.querySelector('.modern-nav:not(.modern-nav--mobile)');
      if (!desktopNav) return;

      const menuItems = desktopNav.querySelectorAll('.modern-nav__item.has-dropdown');
      menuItems.forEach(item => {
        const dropdown = item.querySelector('.modern-nav__dropdown');
        if(!dropdown) return;

        item.addEventListener('mouseenter', () => {
          item.classList.add('is-open');
          dropdown.hidden = false;
        });
        item.addEventListener('mouseleave', () => {
          item.classList.remove('is-open');
          dropdown.hidden = true;
        });
      });
    },

    initSubmenuAccordion() {
      const mobileNav = this.mobileMenu.querySelector('.modern-nav--mobile');
      if (!mobileNav) return;

      mobileNav.addEventListener('click', (e) => {
        const toggle = e.target.closest('.modern-nav__toggle');
        if (!toggle) return;

        e.preventDefault();
        const item = toggle.closest('.modern-nav__item');
        const dropdown = toggle.nextElementSibling;
        
        if (!item || !dropdown || !dropdown.classList.contains('modern-nav__dropdown')) {
          return;
        }

        const isOpening = !item.classList.contains('is-open');

        // Close all other open items within this navigation
        const openItems = mobileNav.querySelectorAll('.modern-nav__item.is-open');
        openItems.forEach(openItem => {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.modern-nav__toggle')?.setAttribute('aria-expanded', 'false');
            const openDropdown = openItem.querySelector('.modern-nav__dropdown');
            if (openDropdown) {
              openDropdown.style.maxHeight = null;
            }
          }
        });
        
        // Toggle the current item
        if (isOpening) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
        } else {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.style.maxHeight = null;
        }
      });
    }
  };

  header.init();
});

// --- Search Modal Toggle ---
const searchModal = document.getElementById('searchModal');
if (searchModal) {
  const searchToggles = document.querySelectorAll('.js-search-toggle');
  const searchCloses = document.querySelectorAll('.js-search-close');
  
  searchToggles.forEach(el => el.addEventListener('click', (e) => {
    e.preventDefault();
    searchModal.classList.add('is-active');
  }));
  
  searchCloses.forEach(el => el.addEventListener('click', (e) => {
    e.preventDefault();
    searchModal.classList.remove('is-active');
  }));
}

// --- Desktop dropdown menu ---
const desktopNav = document.querySelector('.modern-nav:not(.modern-nav--mobile)');
if (desktopNav) {
  const menuItems = desktopNav.querySelectorAll('.modern-nav__item');
  menuItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      if (item.querySelector('.modern-nav__dropdown')) {
        item.classList.add('is-open');
      }
    });
    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-open');
    });
  });
}

// --- Cart count bubble ---
const cartCountBubble = document.querySelector('.cart-count-bubble');
if (cartCountBubble) {
  const observer = new MutationObserver(() => {
    const countText = cartCountBubble.querySelector('span')?.textContent.trim();
    if (countText !== undefined) {
      const count = parseInt(countText, 10);
      cartCountBubble.classList.toggle('has-items', count > 0);
    }
  });

  observer.observe(cartCountBubble, { childList: true, subtree: true });
  
  // Initial check
  const initialCountText = cartCountBubble.querySelector('span')?.textContent.trim();
  if (initialCountText !== undefined) {
      const initialCount = parseInt(initialCountText, 10);
      cartCountBubble.classList.toggle('has-items', initialCount > 0);
  }
}

// --- Sticky Header ---
if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.headerWrapper.classList.toggle('scrolled-past-header', scrollTop > 50);
    }
  });
} 